import { QUERY_PARAMS } from "../utils/helper";
import { customApi } from "./authapi";

customApi.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("cms-ca-token");
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// API for DASHBOARD
export const getAllComplaintsDetails = async (year_name, pageSize) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-total-complaints?year_name=${
        year_name || ""
      }&&pageSize=${pageSize || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response.message || error.message,
    };
  }
};

export const getAllMeasurementDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-monthly-measurement-amount?financial_year=${
        year_name || ""
      }&ro=`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response.message || error.message,
    };
  }
};

export const getAllProformaInvoiceforDashboard = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-monthly-proforma-invoice-amount?financial_year=${
        year_name || ""
      }&ro=`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.message || error.message,
    };
  }
};

export const getAllInvoiceforDashboard = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-monthly-invoice-amount?financial_year=${
        year_name || ""
      }&ro=`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.message || error.message,
    };
  }
};

export const getAllPaymentforDashboard = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-all-payment-recieve-in-dashboard?financial_year=${
        year_name || ""
      }&ro=`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.message || error.message,
    };
  }
};

export const getApiForComplaintsDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-monthly-complaints?year_name=${
        year_name || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getDetailsOfAreaManagerDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-area-managers?year_name=${year_name || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDetailsOfSupervisorDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-supervisor-dashboard?year_name=${year_name || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getDetailsOfEndUserDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-end-users-dashboard?year_name=${
        year_name || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getDetailsOfAreaManagerBillingDetails = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-area-manager-billing-dashboard?financial_year=${
        year_name || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getBillingDetailsOfRegionalOffice = async (year_name) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/dashboard/get-ro-billing-dashboard?financial_year=${
        year_name || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  PREVIOUS DASHBOARD API
export const getAllFinancialYearsForDashboard = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fetch-all-financial-years`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getDetailsOfComplaintInAreaManager = async (
  values,
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/dashboard/get-all-complaints-by-status?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getAllPaymentRecievedListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/payment-received/get-payment-received-by-status?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API"S for OIL AND GAS COMPANY TEAM

export const postEnergyCompany = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/oil-and-gas/create-energy-company-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const createEnergyCompany = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/energy-company/create-energy-company`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAreaManagerInEnergyCompanyById = async (
  energyId,
  areaId,
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/oil-and-gas/get-energy-company-users?id=${
        energyId || ""
      }&&user_id=${areaId || ""}&&search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateEnergyCompany = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/oil-and-gas/update-energy-company-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteEnergyCompanyById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/oil-and-gas/delete-energy-company-user/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Cross-company Energy Team list — backs the Create Team tab list view.
// Server-side search + pagination + optional filters. Same response shape
// as other list endpoints: { status, data, pageDetails }.
export const getAllEnergyTeamMembers = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const { data } = await customApi.get(
      `/api/contractor/oil-and-gas/get-all-energy-team-members${
        queryString ? `?${queryString}` : ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// area manager

export const getallAreaManagerInEnergyCompany = async (
  areaId,
  energy_company_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-area-data-for-energy/${energy_company_id}/${areaId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  FUEL STATION

//API'S FOR OUTLET BY FUEL STATION

export const getAllZoneByOutlet = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/outlets/get-all-zone-for-outlets?id=${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalByOutlet = async (id, zone_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/outlets/get-all-regional-office-for-outlets?id=${id}&zone_id=${zone_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesAreaByOutlet = async (
  id,
  zone_id,
  regional_office_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/outlets/get-all-sales-area-for-outlets?id=${id}&zone_id=${zone_id}&regional_office_id=${regional_office_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// export const getAllDistrict = async () => {
//   try {
//     const { data } = await customApi.get(`/api/contractor/get-all-district`);
//     return data;
//   } catch (error) {
//     return {
//       status: false,
//       message: error.response?.data.message || error.message,
//     };
//   }
// };

export const getAllDistrict = async ({
  search = "",
  pageSize = "",
  pageNo = "",
  energy_company_id = "",
  zone_id = "",
  ro_id = "",
  sale_area_id = "",
  district_id = "",
  status = "",
  fromDate = "",
  toDate = "",
}) => {
  try {
    const params = {
      search: search || undefined,
      pageSize: pageSize || undefined,
      pageNo: pageNo || undefined,
      energy_company_id: energy_company_id || undefined,
      zone_id: zone_id || undefined,
      regional_office_id: ro_id || undefined,
      sales_area_id: sale_area_id || undefined,
      district_id: district_id || undefined,
      status: status || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    };

    // if (fromDate || toDate) {
    //   params.created_at = `${fromDate || ""}${toDate || ""}`;
    // }

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined),
    );

    const queryString = new URLSearchParams(filteredParams);
    const { data } = await customApi.get(
      `/api/contractor/get-all-district?${queryString}`,
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getAllZones = async ({
  search = "",
  pageSize = "",
  pageNo = "",
  energy_company_id = "",
  zone_id = "",

  status = "",
  fromDate = "",
  toDate = "",
}) => {
  try {
    const params = {
      search: search || undefined,
      pageSize: pageSize || undefined,
      pageNo: pageNo || undefined,
      energy_company_id: energy_company_id || undefined,
      zone_id: zone_id || undefined,

      status: status || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined),
    );

    const queryString = new URLSearchParams(filteredParams);
    const { data } = await customApi.get(
      `/api/contractor/get-all-energy-company-zones?${queryString}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllZonesById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-energy-company-zones/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const addZone = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/create-zone`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// update zones
export const updateZone = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `api//contractor/update-zone`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// ADD RO
export const addRO = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/create-regional-office`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateRO = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-regional-office`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getRegionalOfficesonId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-regional-office/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// SALES AREA

export const getSalesAreaonId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/super-admin/sales-area/sales-area-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const addSalesArea = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-sales-area`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// update SalesArea
export const updateSalesArea = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-sales-area`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const addDistrict = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-district`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// update District
export const updateDistrict = async (values, params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-district`,
      values,
      { params: params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllDistrictByOutlet = async (
  id,
  zone_id,
  regional_office_id,
  sales_area_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/outlets/get-all-district-for-outlets?id=${id}&zone_id=${zone_id}&regional_office_id=${regional_office_id}&sales_area_id=${sales_area_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDistrictById = async (id) => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-district/${id}`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postOutlet = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fuel-station/add-outlet`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutlet = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fuel-station/all-outlets?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOutletDropdownData = async (body) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fuel-station/all-outlets-dropdowns`,
      body,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutletById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fuel-station/get-outlet/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateOutlet = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fuel-station/update-outlet`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteOutletById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/fuel-station/delete-outlet/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveRejectOutletById = async (status, outletId) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/fuel-station/approve-reject-outlet-by-id?id=${
        outletId || ""
      }&&status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API FOR SUPPLIER MODULE

export const postSuppliers = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/suppliers/create-suppliers`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSuppliers = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/suppliers/get-suppliers?${queryParams}
   `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Lightweight: returns only the distinct dropdown values (name/gst/state/city/
// pincode) for the Supplier filters, instead of pulling every supplier row.
export const getSupplierFilterOptions = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/suppliers/get-supplier-filter-options`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const checkifsupplieridunique = async (values) => {
  try {
    const { data } = await customApi.post(
      `api/contractor/suppliers/check-if-supplier-unique`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllCompaniesForSupplierChart = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/suppliers/getsupplydataforchart?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllCompaniesForOutletChart = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fuel-station/getoutletsdataforchart?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getsupplierDropdown = async (params) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/suppliers/get-suppliers-dropdown`,
      params,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleSuppliersById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/suppliers/get-suppliers-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSupplierItems = async (supplierId, fromDate, toDate) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    const qs = params.toString();
    const { data } = await customApi.get(
      `/api/contractor/suppliers/get-supplier-items/${supplierId}${qs ? `?${qs}` : ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateSuppliers = async (id, values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/suppliers/update-suppliers/${id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const importSuppliers = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/suppliers/import-suppliers`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteSuppliersById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/suppliers/delete-suppliers/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveRejectSupplierById = async (status, supplierId) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/suppliers/approve-reject-suppliers-by-id?status=${
        status || ""
      }&&id=${supplierId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  State Api's
export const getAllState = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-state-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Bank Data Api's
export const getAllBankData = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-all-bank-list`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S For CONTACT MODULE

export const postContacts = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/contacts/store-company-contact-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllContacts = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/contacts/get-all-stored-company-contact-details?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleContactsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/contacts/get-stored-company-contact-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateContacts = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/contacts/update-stored-company-contact-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteContactsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/contacts/delete-company-contact-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAreaManagerInEnergyCompanyByIdInContact = async (
  energyId,
  areaId,
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/contacts/get-energy-company-users?id=${
        energyId || ""
      }&&user_id=${areaId || ""}&&search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutletInContact = async (
  search,
  pageSize,
  pageNo,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/contacts/all-outlets?search=${search || ""}&&status=${
        status || ""
      }&&pageNo=${pageNo || ""}&&pageSize=${pageSize || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllClientContacts = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/contacts/get-client-users?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSupplierContacts = async (
  search,
  pageSize,
  pageNo,
  isDropdown,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/contacts/get-suppliers?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&isDropdown=${
        isDropdown || ""
      }&&status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// designation
export const getAllStoredContactsPositions = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-stored-company-contact-positions`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// send message
export const postMessages = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/contacts/send-message`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// company data
export const getAllComapnyData = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-company-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S For COMPLAINT MODULE
export const checkiscomplaintidunique = async (values) => {
  try {
    const { data } = await customApi.post(
      `api/contractor/complaint/check-unique-complaint-id`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getRequestComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-requested-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllApprovedUnAssignComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-approved-un-assign-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllApprovedAssignComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-approved-assign-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-approved-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getRejectedComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-rejected-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getResolvedComplaints = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-resolved-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getComplaintsDetailsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-complaints-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getManagerListWithTotalFreeUser = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-manager-list-with-total-free-end-users?complaintId=${
        id || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSupervisorListWithTotalFreeUserByManagerId = async (
  id,
  params,
) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-supervisor-by-manager-with-count-free-end-users/${id}?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllEndUserBySupervisorId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-all-end-users-by-supervisor/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAreaManagerAssign = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-area-manager-assign?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSupervisorAssign = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-supervisor-assign?id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// export const getAllSupervisors = async () => {
//   try {
//     const { data } = await customApi.get(
//       `/api/contractor/get-all-supervisor`
//     );
//     return data;
//   } catch (error) {
//     return {
//       status: false,
//       message: error.response?.data.message || error.message,
//     };
//   }
// };

export const getAllEndUser = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-end-user-assign?id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedComplaintsDetailsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-approved-complaints-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getTotalMemberOnSingleComplaintById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-total-member-on-single-complaint/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getComplaintsTimelineById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/complaints/get-complaints-timeline/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postRejectComplaints = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/complaints/update-complaint-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postRejectApprovedComplaints = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/complaints/rejected-assign-complaint-users`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postAfterAssignCanRejectedComplaints = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/complaints/rejected-assign-complaint-users`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postReactiveRejectComplaints = async (id) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/reactive-complaints-status-update/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postApprovedComplaints = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/approved-complaints`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postAssignComplaintToUser = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/assign-complaint-to-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postHoldComplaintToUser = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/hold-and-transfer-complaints`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateAssignComplaintToUser = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/update-assign-complaint-to-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postChangeStatusComplaints = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/update-allocate-complaints`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postReactiveResolveComplaints = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/complaints/re-work-for-resolved-complaints`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S For FUND MANAGEMENT MODULE

// FUND REQUEST

export const postFundRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-request/request-fund`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFundRequest = async (params) => {
  // const { search, pageSize, pageNo , isDropdown , area_manager_id , supervisor_id , from_date , to_date , created_for , created_for_id  } = payload;
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-request/get-all-fund-requested?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedFundRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-request/get-all-approved-fund-requested?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateItemPriceIfLowPriceThanExisting = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/fund/fund-request/update-item-price-if-low-price-than-existing`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getRejectedFundRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-request/get-all-rejected-fund-requested?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFundRequestById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-request/get-fund-request-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateFundRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-request/update-fund-request-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postFundRequestStatus = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-request/status-changed-of-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postRejectFundRequest = async (id, module, values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/fund/${module}/reject-fund-request/${id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// FUND TRANSFER

export const getAllPendingTransferFundRequest = async (params) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-transfer/get-pending-transfer-fund?${QUERY_PARAMS(params)}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getTransferFund = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-transfer/get-transfer-fund?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const rejectTransferredFund = async (id, rejected_remarks) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-transfer/reject-transfer-fund/${id}`,
      { rejected_remarks: rejected_remarks || "" },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getExpenseFundTransferList = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-expense-fund-transfer-list?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// Read-only preview of what reverting a user-to-user fund transfer would do:
// both parties' before/after balances, the items, and why it may be blocked.
export const getUuTransferRevertPreview = async (transaction_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/uu-transfer-revert-preview?transaction_id=${transaction_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Actually revert the user-to-user fund transfer (money goes back to sender).
export const revertUuFundTransfer = async (transaction_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/revert-uu-fund-transfer`,
      { transaction_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// ── User-to-user STOCK transfers: list + revert ───────────────────────────
export const getExpenseStockTransferList = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-balance/get-expense-stock-transfer-list?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getUuStockRevertPreview = async (transaction_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-balance/uu-stock-revert-preview?transaction_id=${transaction_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const revertUuStockTransfer = async (transaction_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/stock-balance/revert-uu-stock-transfer`,
      { transaction_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllTransferFundRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-transfer/get-all-transfer-fund?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  BANK DROPDOWN

export const getAllBankListForDropdown = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-bank-list?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// OFFICE

export const getAllOfficeUser = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-all-users`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// One user by id, unfiltered — for screens that already know which user they
// are about and must not lose them to the list's own scope/delete filters.
export const getSingleUserById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// MANAGER

export const getAllManagersUser = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-managers-users`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// BANK ACCOUNT

export const getAllAccountByBankId = async (id, user_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-bank-to-account/${id}/${user_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S For EXPENSE MANAGEMENT MODULE

export const getAllExpenseRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/expense/expense-request/get-all-expense-request-by-month?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getExpenseRequestDetails = async (id, month, year) => {
  try {
    const { data } = await customApi.get(
      `api/contractor/fund/expense-punch/get-all-expense-request-by-id/${id}?month=${
        month || ""
      }&year=${year || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getTeamsDetailbyuserid = async (userid) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-team-by-user-id/${userid}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postExpensePunch = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/add-expense-punch`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllExpensePunch = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-all-expense-punch-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// export const getPunchRequest = async (searchTerm, pageSize, pageNo) => {
//   try {
//     const { data } = await customApi.get(
//       `/api/contractor/fund/expense-punch/get-all-expense-punch-list?search=${searchTerm || ""
//       }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`
//     );
//     return data;
//   } catch (error) {
//     return {
//       status: false,
//       message: error.response?.data.message || error.message,
//     };
//   }
// };

export const getPunchRequest = async (
  searchTerm,
  pageSize,
  pageNo,
  filters = {},
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-all-expense-punch-list`,
      {
        params: {
          search: searchTerm || "",
          pageSize: pageSize || "",
          pageNo: pageNo || "",
          ...filters, // 🔥🔥🔥 MAIN FIX
        },
      },
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Punches an approver turned down (status '2'). Returned by no other listing.
export const getRejectedPunchList = async (params = {}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-rejected-punch-list`,
      { params },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedExpensePunch = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-list-expense-punch-approve?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Approved punches PUNCH-WISE (one row per punch, ungrouped) for the
// request-wise tab where per-punch actions (e.g. delete batch) live.
export const getApprovedPunchPunchWise = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-approved-punch-punch-wise?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Preview the whole approval batch of a punch (what + how much will be reverted).
export const getApprovedBatchPreview = async (punch_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/approved-batch-preview?punch_id=${punch_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Delete / revert the whole approval batch of a punch.
export const deleteApprovedBatch = async (punch_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/expense-punch/delete-approved-batch`,
      { punch_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Adjust (reduce) approved punch quantities — qty-only partial reversal.
// edits: [{ id, new_qty }]
export const adjustApprovedPunch = async (punch_id, edits) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/expense-punch/adjust-approved-punch`,
      { punch_id, edits },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// ── Approved STOCK punches — request-wise (mirror of expense above) ────────
export const getApprovedStockPunchPunchWise = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-approved-stock-punch-punch-wise?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Preview the whole approval batch of a stock punch (wallet debit + Cash credit).
export const getApprovedStockBatchPreview = async (punch_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/approved-stock-batch-preview?punch_id=${punch_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Delete / revert the whole approval batch of a stock punch.
export const deleteApprovedStockBatch = async (punch_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/stock-punch-approve/delete-approved-stock-batch`,
      { punch_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Adjust (reduce) approved STOCK punch quantities — qty-only partial reversal.
// Mirror of adjustApprovedPunch. edits: [{ id, new_qty }]
export const adjustApprovedStockPunch = async (punch_id, edits) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/stock-punch-approve/adjust-approved-stock-punch`,
      { punch_id, edits },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllItemMasterForDropdownUsingUserid = async (userid) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-user-fund-items-lists/${userid}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getUserWalletDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-user-wallet-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleExpensePunchById = async (
  id,
  complaint_id,
  includeApproved = false,
  punchDate,
) => {
  try {
    // Build query params so day-scoping (punch_date) is optional and
    // backward compatible: absent punchDate => identical URL as before.
    const params = [];
    if (includeApproved) params.push("includeApproved=1");
    if (punchDate) params.push(`punch_date=${encodeURIComponent(punchDate)}`);
    const queryString = params.length ? `?${params.join("&")}` : "";
    const { data } = await customApi.get(
      `/api/contractor/fund/expense-punch/get-expense-punch-details/${complaint_id}/${id}${queryString}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postApprovePunch = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/fund/expense-punch/update-approve-qty`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Delete a PENDING (un-approved) expense punch row from Approve & Check.
export const deletePendingPunch = async (punch_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/expense-punch/delete-pending-punch`,
      { punch_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// REGIONAL OFFICE
export const getAllRegionalOffice = async ({
  search = "",
  pageSize = "",
  pageNo = "",
  energy_company_id = "",
  zone_id = "",
  ro_id = "",

  status = "",
  fromDate = "",
  toDate = "",
  for_expense_punching = "",
}) => {
  try {
    // const queryParams = QUERY_PARAMS(params);
    const params = {
      search: search || undefined,
      pageSize: pageSize || undefined,
      pageNo: pageNo || undefined,
      energy_company_id: energy_company_id || undefined,
      zone_id: zone_id || undefined,
      ro_id: ro_id || undefined,
      status: status || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
      for_expense_punching: for_expense_punching || undefined,
    };
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined),
    );

    const queryString = new URLSearchParams(filteredParams).toString();

    const { data } = await customApi.get(
      `/api/contractor/all-regional-offices?${queryString}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalOfficebyIdArray = async (params) => {
  try {
    const { data } = await customApi.post(
      `api/contractor/get-all-regional-office-detail/by-po`,
      params || [],
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getAllRegionalOfficeList = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-regional-office-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllROData = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-regional-office-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApproveExpensePunchDetails = async (
  id,
  complaint_id,
  from_date,
  to_date,
) => {
  try {
    let url = `/api/contractor/fund/expense-punch/get-list-expense-punch-approve_according_to_items?complaint_id=${complaint_id}&&user_id=${id}`;
    if (from_date) url += `&fromDate=${from_date}`;
    if (to_date) url += `&toDate=${to_date}`;
    const { data } = await customApi.get(url);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllUsersForExpenses = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-users-for-expenses`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllItemMasterForDropdown = async (category) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-item-master-for-dropdown?category=${
        category || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR STOCK MANAGEMENT MODULE

export const postStockRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/save-stock-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedStockRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-all-approved-requested-stock?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-all-requested-stock?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockRequestById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-single-requested-stock-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPreviousItemsStockList = async (id, transferDate) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-all-items-in-stocks-by-userId/${id}${
        transferDate ? `?transfer_date=${transferDate}` : ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateStockRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/stock-request/update-stock-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postStockReject = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/stock-request/rejected-stock-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postRejectStockRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/stock-request/rejected-stock-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postStockRequestStatus = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/stock-request/change-stock-request`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// export const getRejectedStockRequest = async (search, pageSize, pageNo) => {

//   try {
//     const { data } = await customApi.get(
//       `/api/contractor/stock/stock-request/get-all-rejected-requested-stock?pageSize=${pageSize || ""
//       }&&pageNo=${pageNo || ""}&&search=${search || ""}`
//     );
//     return data;
//   } catch (error) {
//     return {
//       status: false,
//       message: error.response?.data.message || error.message,
//     };
//   }
// };

export const getRejectedStockRequest = async (payload = {}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-all-rejected-requested-stock`,
      {
        params: {
          ...payload,
        },
      },
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllStockRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    // const { data } = await customApi.get(
    //   `api/contractor/stock/stock-request/get-all-stock-requests?pageSize=${pageSize || ""
    //   }&&pageNo=${pageNo || ""}&&search${search || ""}`
    // );
    const { data } = await customApi.get(
      `/api/contractor/stock/stock-request/get-all-stock-requests?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPendingTransferStockRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/transfer-stock/get-all-pending-stock-transfer-request?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getTransferStock = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/transfer-stock/get-transfer-stock?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const rejectTransferredStock = async (id, rejected_remarks) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock/transfer-stock/reject-transfer-stock/${id}`,
      { rejected_remarks: rejected_remarks || "" },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPaymentModes = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-payment-methods`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPaymentMethod = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-payment-methods?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllTransferStockRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock/transfer-stock/get-all-transfer-stock?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR STOCK PUNCH MANAGEMENT MODULE

export const getAllStockPunchRequest = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-request/get-stock-request-month-wise`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockPunchRequestDetails = async (
  id,
  month,
  search,
  pageSize,
  pageNo,
  punchDate,
) => {
  try {
    const { data } = await customApi.get(
      `api/contractor/stock-punch/stock-punch-request/get-all-stock-request-by-id/${id}?search=${
        month || ""
      }${punchDate ? `&punch_date=${punchDate}` : ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Backward-compatible: callers passing 3 positional args (search, pageSize,
// pageNo) keep working — `filters` defaults to {} so no extra params are
// sent. Newer callers (StockBalanceOverview Approve & Check screen) pass
// `dropdownOptions` as the 4th arg to forward filter values to the backend.
export const getStockPunchDetails = async (
  searchTerm,
  pageSize,
  pageNo,
  filters = {},
) => {
  try {
    const params = new URLSearchParams();
    if (searchTerm) params.set("search", searchTerm);
    if (pageSize) params.set("pageSize", pageSize);
    if (pageNo) params.set("pageNo", pageNo);
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") params.set(k, v);
    });
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-all-stock-punch-list?${params.toString()}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Delete a PENDING (un-approved) stock punch row from Approve & Check.
export const deletePendingStockPunch = async (punch_id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/stock-punch-approve/delete-pending-stock-punch`,
      { punch_id },
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllStockPunch = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-all-stock-punch-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedStockPunch = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-all-approve-stock-punch?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockPunchFullDetails = async (id, complaint_id, punchDate) => {
  try {
    // DAY-WISE: optional punchDate scopes the detail to a single day. When
    // omitted the URL is byte-identical to before (backward compatible).
    const dayQuery = punchDate
      ? `?punch_date=${encodeURIComponent(punchDate)}`
      : "";
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-stock-punch-details/${id}/${complaint_id}${dayQuery}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleStockPunchById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-stock-punch-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getStockPunchDetailsById = async (id, complaint_id, punchDate) => {
  try {
    // DAY-WISE: optional punchDate scopes the approve detail to a single day.
    // When omitted the URL is byte-identical to before (backward compatible).
    const dayQuery = punchDate
      ? `?punch_date=${encodeURIComponent(punchDate)}`
      : "";
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-stock-punch-details/${id}/${complaint_id}${dayQuery}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postApproveStockPunch = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/stock-punch-approve/approve-stock-punch-quantity`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApproveStockPunchDetails = async (id, params = {}) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-approve/get-all-approve-stock-punch-by-id/${id}?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postStockPunch = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/save-stock-punch`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockPunchTransferList = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-transfer/get-stock-quantity-transfer?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getStockPunchTransferedDetails = async (
  transfer_by,
  transfer_to,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch/stock-punch-transfer/get-stock-quantity-transfer-by-id/${transfer_by}/${transfer_to}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postStockPunchTransfer = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/stock-punch/stock-punch-transfer/new-stock-transfer`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR EARTHING TESTING MODULE
export const postEarthingTesting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/earthing-testing/add-earthing-testing-report`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllEarthingTesting = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/earthing-testing/get-earthing-testing-lists?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleEarthingTestingById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/earthing-testing/get-earthing-testing-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateEarthingTesting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/earthing-testing/update-earthing-testing-detail`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveRejectEarthingTestingById = async (
  status,
  earthingTestingId,
) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/earthing-testing/approve-reject-earthing-testing-by-status?id=${
        earthingTestingId || ""
      }&&status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR BILLING MODULE

// MEASUREMENT

export const getAllSalesAreaNameForMeasurement = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-sale-in-ptm?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutletNameForPTM = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-outlets-in-ptm?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalNameForPTM = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-regionals-in-ptm?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOrderByForPTM = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-order-by-in-ptm?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllCompanyForPTM = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-companies-in-ptm?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintInMeasurement = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-complaint-types?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeForPTM = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-complaint-types?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPoNumberForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-po-in-billing?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const generateComplaintReportPdf = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-complaint-report?${queryParams}`,
      { responseType: "blob" },
    );
    // `headers` must be passed through: the caller reads Content-Disposition
    // from it to name the saved file. Returning only `data` silently dropped
    // the header, so every download fell back to the hardcoded
    // "COMPLAINT_REPORT.PDF" no matter what the server named the report.
    return { status: true, data: response.data, headers: response.headers };
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateComplaintReportExcel = async (params) => {
  try {
    const queryParams = QUERY_PARAMS({ ...params, format: "excel" });
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-complaint-report?${queryParams}`,
      { responseType: "blob" },
    );
    // Headers passed through for the same reason as the PDF helper above.
    return { status: true, data: response.data, headers: response.headers };
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getAllComplaintsForMeasurement = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/get-resolved-complaint-in-billing?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postHardCopiesInMeasurements = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/measurement/files-upload-in-billing`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postMeasurements = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/measurement/create-measurement`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllmeasurementByStatus = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-measurements-based-on-status?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesAreaNameForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-sales-in-billing?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletNameForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-outlet-in-billing?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalNameForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-regional-in-billing?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOrderByForBilling = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-order-by-for-measurements?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllCompanyForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-companies-in-billing?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDetailsOfProcessToMeasurement = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-measurements-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleMeasurementsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-measurements-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const downloadMeasurementBill = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-measurements-details/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getDetailsofComplaintsInMeasurement = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-pi-attachment-by-complaint-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getApiToForStockAndFundDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-approved-data/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllFinancialYears = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fetch-all-financial-years?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPoDetails = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/get-all-po-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllItemsOnPoNumber = async (po_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-purchase-order-details-with-items/${po_id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllItemsByPoId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-purchase-order-details-with-items/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getMeasurementTimeHistory = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-measurements-timeline-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const discardMeasurementsById = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/measurement/discard-measurement-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPoBasedOnRo = async (po, ro) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-po-exists-or-not?po=${
        po || ""
      }&&ro=${ro || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const changePoNumber = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/measurement/change-po-details-by-same-po`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// PERFORMA INVOICE
export const getAllSalesAreaforfilter = async (status, po_id, ro_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-sa-filters?status=${status || ""}&&po_id=${
        po_id || ""
      }&&ro_id=${ro_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getComplainDetailsForMeasurement = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-complaints-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllReadyToPi = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/performa-invoice/get-measurements-in-pi-status?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPerformaInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/performa-invoice/get-all-proforma-invoices?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// MERGED_PERFORMA_INVOICE

export const getComplaintsListingToMerge = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-performa/get-all-pi-merged-performa?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllMergedToPiListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-performa/get-all-merged-proforma-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// INVOICE

export const getAllInvoiceListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-all-listing-pi-and-mpi?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllFinalInvoicesListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-all-invoice-data?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// MERGED_INVOICE

export const getAllMergeInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-invoice/get-all-merged-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// PAYMENTS

// filters (optional): { po_id, ro_id, billing_from, billing_to, from_date, to_date }
export const getAllFinalInvoices = async (pageSize, pageNo, search, filters = {}) => {
  try {
    const queryParams = QUERY_PARAMS({ search, pageSize, pageNo, ...filters });
    const { data } = await customApi.get(
      `/api/contractor/billing/payments/get-all-invoice-in-payments?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// PDF of the Payments list for the same search / filters.
export const downloadPaymentsListPdf = async (search, filters = {}) => {
  try {
    const queryParams = QUERY_PARAMS({ search, ...filters, pdf: 1 });
    return await customApi.get(
      `/api/contractor/billing/payments/get-all-invoice-in-payments?${queryParams}`,
      { responseType: "blob" },
    );
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Transferred Fund / Transferred Stock: read and edit a transfer's
// Transaction ID / Remark. kind "fund" → id is the transfer (account
// transaction); kind "stock" → id is the stock request.
export const getTransferDetails = async (kind, id) => {
  try {
    const base = kind === "stock" ? "stock/transfer-stock" : "fund/fund-transfer";
    const { data } = await customApi.get(`/api/contractor/${base}/transfer-details/${id}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};
// User statement (View Transaction): edit one entry's Narration and
// Transaction ID. values: { id (the entry's txn_row_id), description, transaction_id }
export const updateUserTransactionDetails = async (values) => {
  try {
    const { data } = await customApi.put(`/api/contractor/master-data/accounts/update-user-transaction-details`, values);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Bank statement (View Transaction): edit one entry's Remark and Transaction
// ID. values: { id (the entry's bank_txn_row_id), description, transaction_id }
export const updateBankTransactionDetails = async (values) => {
  try {
    const { data } = await customApi.put(`/api/contractor/master-data/accounts/update-bank-transaction-details`, values);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Every transfer of one fund / stock request (date, amount, bank, transaction
// id, remark) — the request's View page.
export const getRequestTransfers = async (kind, requestId) => {
  try {
    const base = kind === "stock" ? "stock/transfer-stock" : "fund/fund-transfer";
    const { data } = await customApi.get(`/api/contractor/${base}/request-transfers/${requestId}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};
export const updateTransferDetails = async (kind, values) => {
  try {
    const base = kind === "stock" ? "stock/transfer-stock" : "fund/fund-transfer";
    const { data } = await customApi.put(`/api/contractor/${base}/update-transfer-details`, values);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// PO / RO / Billing From / Billing To options of a Merged PI tab (status 6 / 4 / 5).
export const getMergedPiFilterOptions = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-performa/get-merged-pi-filter-options?status=${status}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Same options for the invoice lists:
//   { mode: "final", merged_invoice_status: 1 | 2 }  → Final Bill / its Discard
//   { mode: "running", status: 1 | 2 }               → Running Bill / discarded running bills
export const getInvoiceFilterOptions = async (params) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-invoice-filter-options?${QUERY_PARAMS(params)}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// PDF of a payment list — status 1 partial, 2 done, 3 Retention → All Paid
// Bills — with { pv_number, invoice_number, from_date, to_date, search }.
// Saves the file in the browser; returns { status, message }.
export const downloadPaymentReceivedPdf = async (params) => {
  try {
    const res = await customApi.get(
      `/api/contractor/billing/payment-received/payment-received-pdf?${QUERY_PARAMS(params)}`,
      { responseType: "blob" },
    );
    const cd = res.headers?.["content-disposition"] || "";
    const match = cd.match(/filename="?([^";\n]+)"?/);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", match ? match[1] : "PAYMENTS.PDF");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { status: true };
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// List PDF of Retention → Eligible (1) / Process (2) / Done (3): the same
// params as getAllEligibleAndDoneRetentions. Saves the file in the browser.
export const downloadRetentionListPdf = async (params) => {
  try {
    const res = await customApi.get(
      `/api/contractor/billing/retention/get-all-payment-retention?${QUERY_PARAMS({ ...params, pdf: 1 })}`,
      { responseType: "blob" },
    );
    if (res.data?.type?.includes("json")) {
      const body = JSON.parse(await res.data.text());
      return { status: false, message: body.message || "No data for these filters" };
    }
    const cd = res.headers?.["content-disposition"] || "";
    const match = cd.match(/filename="?([^";\n]+)"?/);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", match ? match[1] : "RETENTION.PDF");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { status: true };
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Invoice No. options of Payment Received (1 partial, 2 done) / Retention → All Paid Bills (3).
export const getPaymentInvoiceNumbers = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/payment-received/listing-invoice-number?status=${status}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// PO / RO / Billing From / Billing To options of the Payments list.
export const getPaymentsFilterOptions = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/payments/get-payments-filter-options`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// PAYMENTS_RECEIVED

export const getAllPVNumber = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/payment-received/listing-pv-number?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// RETENTION_MONEY

// filters (optional): { invoice_number, from_date, to_date }
export const getAllPaymentDoneListingInRetention = async (
  pageSize,
  pageNo,
  search,
  pv_number,
  filters = {},
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/retention/get-payment-received-in-retention-by-status?${QUERY_PARAMS({
        search,
        pageSize,
        pageNo,
        pv_number,
        ...filters,
      })}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllEligibleAndDoneRetentions = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/billing/retention/get-all-payment-retention?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR OFFICE INSPECTION MODULE

export const getOfficeExpenseRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-all-outlet-with-complaints?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeExpenseRequestForPartial = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/stock-office-expense-partial-by-office?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeExpenseRequestForApproved = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/stock-office-expense-approved-by-office?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeExpenseRequestByOutletIdForPending = async ({
  outlet_id,
  month,
  params,
}) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-all-outlet-with-complaints-by-id/${
        outlet_id || null
      }/${month}?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postStockPunchApproveByOffice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/office-inspection/stock-punch-approve-by-office`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeExpenseRequestByOutletIdForApproved = async (
  outlet_id,
  month,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-office-approved-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeExpenseRequestByOutletIdForPartial = async (
  outlet_id,
  month,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-stock-office-partial-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postFundPunchApproveByOffice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/office-inspection/fund-punch-approve-by-office`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postTransferExpenseFund = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-transfer/transfer-expense-fund`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postTransferExpenseStock = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fund/fund-transfer/transfer-expense-stock`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficePendingFundRequest = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-all-outlet-with-complaints-funds?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeFundRequestByOutletIdForPending = async ({
  outlet_id,
  month,
  params,
}) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-all-outlet-with-complaints-funds-by-id/${
        outlet_id || null
      }/${month}?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeFundRequestForPartial = async (
  sales_area_id,
  regional_office_id,
  outlet_id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/fund-office-expense-partial-by-office?outlet_id=${
        outlet_id || ""
      }&&regional_office_id=${regional_office_id || ""}&&sales_area_id=${
        sales_area_id || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeFundRequestByOutletIdForPartial = async (
  outlet_id,
  month,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-fund-office-partial-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeFundRequestForApproved = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/fund-office-expense-approved-by-office?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getOfficeFundRequestByOutletIdForApproved = async (
  outlet_id,
  month,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-office-approved_fund-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutletForFundInOffice = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-outlet-office-by-id-for-fund?status=${
        status ?? ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesForFundInOffice = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-sales-area-office-by-id-for-fund?status=${status}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalForFundInOffice = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/office-inspection/get-regional-office-expense-by-id-for-fund?status=${
        status ?? ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR SITE INSPECTION MODULE
export const getSiteExpensePendingRequest = async (
  sales_area_id,
  regional_office_id,
  outlet_id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/site-inspection/get-all-site-inspections?outlet_id=${
        outlet_id || ""
      }&&regional_office_id=${regional_office_id || ""}&&sales_area_id=${
        sales_area_id || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getPartialExpenseOfSiteInspection = async (
  sales_area_id,
  regional_office_id,
  outlet_id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/site-inspection/get-partial-site-inspections?outlet_id=${
        outlet_id || ""
      }&&regional_office_id=${regional_office_id || ""}&&sales_area_id=${
        sales_area_id || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSiteExpenseRequestForApproved = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/site-inspection/get-approved-site-inspections?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getPendingSiteExpenseRequestData = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/site-inspection/get-site-inspections-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postStockPunchApproveBySite = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/site-inspection/approved-site-inspections`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getApprovedSiteExpenseRequestData = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/site-inspection/get-site-inspections-approved-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postAssignEmployeeforFund = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/site-inspection/assign-complaints-in-fund-site-inspection`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR PURCHASE AND SALES MODULE

// PURCHASE ORDER

export const postPurchaseOrder = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/purchase/create-po-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPurchaseOrder = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/purchase/get-all-generated-po?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRoInSecurityEligible = async (status, po_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-ro-for-po?status=${
        status || ""
      }&&po_id=${po_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPoInSecurityEligible = async (status, ro_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-po-number-for-po?status=${
        status || ""
      }&&ro=${ro_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveEligibleSecurity = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/approve-purchase-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const PostApproveSecurityRefund = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/purchase/approve-update-purchase-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSecurityIdListing = async (status, poId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-security-unique-id?status=${
        status || ""
      }&&po=${poId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSinglePurchaseOrderById = async (
  id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/purchase/get-single-po-details/${id}?pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}&&search=${search || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllFromCompanies = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-from-companies`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updatePurchaseOrder = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/purchase/update-po-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deletePurchaseOrderById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/purchase-sale/purchase/delete-po-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getCheckPoIsExists = async (search) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/check-po-is-exists?search_value=${search}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getPoOnRoId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-po-details-on-ro/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postTaxCalculationType = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/get-tax-calculation-type`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllGstTypes = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-all-gst-type`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postChangePoStatus = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/purchase/change-po-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// SALES ORDER

export const postSalesOrder = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/sales/create-so-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateSalesOrder = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/sales/update-so-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesOrder = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/sales/get-all-generated-so?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleSalesOrderById = async (id, params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/sales/get-single-so-details/${id}?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteSalesOrderById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/purchase-sale/sales/delete-so-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getCheckSoIsExists = async (search) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/check-so-is-exists?search_value=${search}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postChangeSoStatus = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/sales/change-so-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveEligibleSecurityInSo = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/approve-sales-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const PostApproveSecurityRefundInSo = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/purchase-sale/approve-update-sales-order`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSecurityIdListingInSo = async (status, soId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-sales-security-unique-id?status=${
        status || ""
      }&&so=${soId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRoForSoInSecurityEligible = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-ro-for-so?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSoInSecurityEligible = async (status, ro_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/purchase-sale/get-so-number-for-so?status=${
        status || ""
      }&&ro=${ro_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR WORK QUOTATION MODULE

export const postQuotation = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/quotations/create-quotation`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getWorkQuotation = async (search, pageSize, pageNo, status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/quotations/get-quotation?status=${
        status || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getQuotationById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/quotations/get-quotation-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateQuotation = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/quotations/update-quotation/${values.id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteQuotationById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/quotations/delete-quotation/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveRejectQuotationById = async (status, quotationId) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/quotations/approve-rejected-quotation-by-id?status=${
        status || ""
      }&&id=${quotationId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR PRODUCT MANAGEMENT MODULE

// CATEGORY

export const postProductCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/category/create-category`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllProductCategory = async ({
  search,
  pageSize,
  pageNo,
  isDropdown,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/category/get-all-category?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&isDropdown=${
        isDropdown || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleProductCategoryById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/category/get-category-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateProductCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/category/update-category-detail`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteProductCategoryById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/product-management/category/delete-category-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// UNIT

export const postUnitData = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/unit/create-unit-data`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllUnitData = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/unit/get-all-unit-data?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleUnitDataById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/unit/get-unit-data-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateUnitData = async (id, values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/product-management/unit/update-unit-data-by-id/${id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteUnitDataById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/product-management/unit/delete-unit-data-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// PRODUCT
export const getAllProductDetails = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/product/product-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postProductDetails = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/product/product-add`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleProductById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-management/product/product-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateProductDetails = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/product/product-detail-update`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPublishStatusUpdate = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/product-management/product/product-publish-status-update`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR ASSETS MANAGEMENT MODULE

export const postAssets = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assets/add-new-assets`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllAssets = async ({
  search,
  pageSize,
  pageNo,
  isDropdown,
  status,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/assets/get-all-stored-assets?status=${
        status || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }&&isDropdown=${isDropdown || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleAssetsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/assets/get-stored-assets-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateAssets = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assets/update-stored-assets`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteAssetsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/assets/delete-stored-assets/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postAssignedAssetToUser = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/assets/assigned-asset-to-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllAssignedAssetsToUser = async ({
  search,
  pageSize,
  pageNo,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/assets/get-all-assigned-asset-to-users?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const approveRejectAssetsManagementById = async (status, assestsId) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/assets/approve-reject-assets-by-status?status=${
        status || ""
      }&&id=${assestsId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const sendToRepair = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assets/repair-assets`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAssetsTimelineHistoryById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-assets-with-timeline-history/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR COMMUNICATION MODULE

export const getNewUserChat = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/communication/add-new-user-to-chat`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllMessages = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/communication/get-messages`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const AddnewUsertoChat = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/communication/start-chat-to-new-user/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllSendMessages = async (
  search,
  pageSize,
  pageNo,
  upcoming,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/communication/get-all-messages?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&upcoming=${
        upcoming || ""
      }&&status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR HR  MANAGEMENT MODULE

// ATTENDANCE

export const getAllUsersAttendanceInCalendar = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/hr-attendance/get-all-users-attendance-in-calendar-view?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postMarkManualAttendance = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/hr-attendance/mark-manual-attendance`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postMarkBulkAttendance = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/hr-attendance/mark-attendance-in-bulk`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR MASTER DATA MODULE

// BANK
export const getAllBankList = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/bank/get-bank-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postBankList = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bank/add-bank-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleBankListById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/bank/get-bank-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateBankList = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bank/update-bank-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  ACCOUNTS
export const postAccountDetails = async (formData) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/accounts/add-bank-account-details`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const addCreditor = async (formData) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bank/add-creditor-details`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const addBankToBankTransfer = async (formData) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/bank-to-bank-transaction`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateBankToBankTransfer = async (formData) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-bank-to-bank-transaction`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateCreditor = async (formData, id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bank/update-creditor-details/${id}`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllAccountDetails = async (
  search,
  pageSize,
  pageNo,
  user_id,
  user_type,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/accounts/get-all-account-details?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&user_id=${user_id || ""}&&user_type=${user_type || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllAccountDetailsForExport = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/master-data/accounts/get-all-account-details?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleAccountDetailsById = async (id, user_type) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/accounts/account-details-by-id/${id}/${user_type}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAccountTransactionHistory = async (
  id,
  filterBy,
  pageSize,
  pageNo,
  fromDate,
  toDate,
  isuser,
  transactionType,
  complaint_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/accounts/get-account-transaction-history/${id}?date=${filterBy}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}&&fromDate=${fromDate || ""}&&toDate=${toDate || ""}&&isuser=${isuser || ""}&&transactionType=${transactionType || ""}&&complaint_id=${complaint_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateAccountDetails = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/accounts/update-account-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteAccountDetailsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/accounts/delete-account-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const generateUserReport = async (userId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-report/${userId}?fromDate=${fromDate}&toDate=${toDate}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Item-wise user report (PDF) — lists each received item with when it was
// transferred and when it was punched. Separate endpoint from the summary
// report (generateUserReport) so the existing report is untouched.
export const generateUserItemwiseReport = async (userId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-itemwise-report/${userId}?fromDate=${fromDate}&toDate=${toDate}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Item-wise user report (Excel) — same endpoint with format=excel.
export const generateUserItemwiseExcelReport = async (
  userId,
  fromDate,
  toDate,
) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-itemwise-report/${userId}?fromDate=${fromDate}&toDate=${toDate}&format=excel`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// User-wise hierarchy report (User Accounts screen → "User-wise Report").
// Root user = selected Manager / Supervisor / End User. format: "pdf" | "excel".
export const downloadUserWiseReport = async (
  userId,
  fromDate,
  toDate,
  format = "pdf",
  filters = {},
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    // Pass the screen filters so the report resolves the SAME users the list
    // shows (manager → supervisors → end users).
    if (filters.manager) params.append("manager", filters.manager);
    if (filters.supervisor) params.append("supervisor", filters.supervisor);
    if (filters.end_user) params.append("end_user", filters.end_user);
    if (filters.role) params.append("role", filters.role);
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-wise-report/${userId}${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Complaint Wise Report (User Accounts screen → 3rd dropdown option).
// Streams a PDF or Excel of complaints grouped by user filters, showing
// per-complaint Man Power / Stock Punch / Expense Punch for prev + current
// month. Uses the SAME formulas as the Complaint Summary Report.
// User Accounts Item-wise Report: page 1 = the Summary report, then every item
// the filtered hierarchy received. Same filters as the User Accounts screen.
export const downloadUserAccountsItemwiseReport = async (
  fromDate,
  toDate,
  format = "pdf",
  filters = {},
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    if (filters.manager) params.append("manager", filters.manager);
    if (filters.supervisor) params.append("supervisor", filters.supervisor);
    if (filters.end_user) params.append("end_user", filters.end_user);
    if (filters.role) params.append("role", filters.role);
    if (filters.emplyoee_id) params.append("emplyoee_id", filters.emplyoee_id);
    if (filters.search) params.append("search", filters.search);
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-accounts-itemwise-report${qs ? `?${qs}` : ""}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadComplaintWiseReport = async (
  fromDate,
  toDate,
  format = "pdf",
  filters = {},
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    // Pass the User Accounts screen filters so the same hierarchy/user set
    // narrows the complaint report.
    if (filters.manager) params.append("manager", filters.manager);
    if (filters.supervisor) params.append("supervisor", filters.supervisor);
    if (filters.end_user) params.append("end_user", filters.end_user);
    // Role dropdown (SUPERVISOR / MANAGER / etc.) and Employee Name dropdown
    // must reach the backend so the report reflects the SAME user hierarchy
    // the User Accounts list is showing. Backend passes both through
    // _captureUserWiseList → user set → complaint IN(...) filter.
    if (filters.role) params.append("role", filters.role);
    if (filters.emplyoee_id) params.append("emplyoee_id", filters.emplyoee_id);
    if (filters.status) params.append("status", filters.status);
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-complaint-wise-report${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateUserExcelReport = async (userId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-user-report/${userId}?fromDate=${fromDate}&toDate=${toDate}&format=excel`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateBankReport = async (accountId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-bank-report/${accountId}?fromDate=${fromDate}&toDate=${toDate}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateBankExcelReport = async (accountId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-bank-report/${accountId}?fromDate=${fromDate}&toDate=${toDate}&format=excel`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateSupplierReport = async (supplierId, fromDate, toDate) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-supplier-report/${supplierId}?fromDate=${fromDate}&toDate=${toDate}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const generateSupplierExcelReport = async (
  supplierId,
  fromDate,
  toDate,
) => {
  try {
    const response = await customApi.get(
      `/api/contractor/fund/reports/generate-supplier-report/${supplierId}?fromDate=${fromDate}&toDate=${toDate}&format=excel`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved Fund Request — Excel report (filtered or current-month default).
// Forwards the same query params the screen uses, so the report content
// matches the visible list exactly. Returns the raw axios response so the
// caller can read the binary body + Content-Disposition header.
export const downloadApprovedFundRequestExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/approved-fund-request-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApprovedFundRequestPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/approved-fund-request-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Transferred Fund — Excel report (filtered or current-month default).
// Forwards the same query params the screen uses, so the report content
// matches the visible list exactly. Returns the raw axios response so the
// caller can read the binary body + Content-Disposition header.
export const downloadTransferredFundExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/transferred-fund-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadTransferredFundPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/transferred-fund-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Pending Fund Transfer — Excel + PDF report. FIFO-ordered (oldest creation
// date first). Forwards the same filter params the Pending Transfer screen uses.
export const downloadPendingTransferExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/pending-transfer-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadPendingTransferPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/pending-transfer-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved Fuel-Station Outlet — Excel + PDF report (filtered or
// current-month default). Forwards the SAME filter params the Approved
// screen uses so the file content matches the visible list exactly.
// Returns the raw axios response so the caller can read the binary body +
// Content-Disposition header.
// When the request is made with `responseType: "blob"`, axios delivers the
// error body as a Blob — so `error.response.data.message` is always undefined.
// Read the blob's text and parse JSON to surface the actual backend message
// (otherwise the toast just says "Request failed with status code 400").
const _extractBlobErrorMessage = async (error, fallback) => {
  try {
    const data = error?.response?.data;
    if (data && typeof data.text === "function") {
      const text = await data.text();
      try {
        const parsed = JSON.parse(text);
        if (parsed?.message) return parsed.message;
      } catch (_) {}
      if (text) return text;
    }
  } catch (_) {}
  return error?.message || fallback;
};

export const downloadApprovedFuelStationExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fuel-station/reports/approved-fuel-station-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    const message = await _extractBlobErrorMessage(
      error,
      "Failed to download Excel report",
    );
    return { status: false, message };
  }
};

export const downloadApprovedFuelStationPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fuel-station/reports/approved-fuel-station-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    const message = await _extractBlobErrorMessage(
      error,
      "Failed to download PDF report",
    );
    return { status: false, message };
  }
};

// Pending Punch (Fund → Expense Punch → Pending Request) — Excel + PDF.
// Forwards the same filter params the screen uses; backend forces
// `for_expense_punch=true` + `isDropdown=true` for the full filtered list.
export const downloadPendingPunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/pending-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadPendingPunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/pending-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved Punch (Fund → Expense Punch → Approved Punch) — Excel + PDF.
// Forwards the same filter params the screen sends to
// `getApprovedExpensePunch`; backend defaults the date range to the
// current month when neither bound is supplied.
export const downloadApprovedPunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/approved-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApprovedPunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/approved-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Item-Wise Report — same Approved Punch tab, one row per punch item.
// Reuses the item-wise endpoint the on-screen listing already computes.
export const downloadItemWisePunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/item-wise-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadItemWisePunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/fund/reports/item-wise-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved Stock Request (Stock → Stock Request → Approved) — Excel + PDF.
// Forwards the same filter params the screen sends to
// `getApprovedStockRequest`; backend defaults the date range to the
// current month when neither bound is supplied.
export const downloadApprovedStockExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/approved-stock-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApprovedStockPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/approved-stock-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Pending Stock Transfer (Stock → Stock Transfer → Pending Transfer) — Excel + PDF.
// Forwards the same filter params the screen sends to
// `getAllPendingTransferStockRequest`; backend defaults the date range to
// the current month when neither bound is supplied.
export const downloadPendingStockTransferExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/pending-stock-transfer-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadPendingStockTransferPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/pending-stock-transfer-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Transferred Stock (Stock → Stock Transfer → Transferred Stock) — Excel + PDF.
// Forwards the same filter params the screen sends to `getTransferStock`;
// backend defaults the date range to the current month when neither bound
// is supplied.
export const downloadTransferredStockExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/transferred-stock-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadTransferredStockPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/transferred-stock-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Stock Expense Punch — Pending Request (Stock → Expense Punch → Pending
// Request) — Excel + PDF. Forwards the same filter params the screen sends
// to `getTransferStock` with `for_expense_punch: true`; backend defaults
// the date range to the current month when neither bound is supplied.
export const downloadStockExpensePunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/stock-expense-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// ONE employee's pending punch, request-wise (Pending Request row PDF icon).
// params: { user_id, fromDate?, toDate? } — the screen's date filter.
// `kind` "fund" = Expense Punch, "stock" = Stock Punch.
export const downloadPendingPunchUserPdf = async (kind, params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const path =
      kind === "stock"
        ? "stock/reports/stock-expense-punch-user-pdf"
        : "fund/reports/pending-punch-user-pdf";
    return await customApi.get(`/api/contractor/${path}?${queryString}`, {
      responseType: "blob",
    });
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadStockExpensePunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock/reports/stock-expense-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved Stock Punch (Stock → Expense Punch → Approved Punch) — Excel + PDF.
// Forwards the same filter params the screen sends to `getApprovedStockPunch`;
// backend defaults the date range to the current month when neither bound
// is supplied.
export const downloadApproveStockPunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock-punch/reports/approve-stock-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApproveStockPunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock-punch/reports/approve-stock-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Stock Item Wise Report (Stock → Expense Punch → Approved Punch) — Excel + PDF.
// Same param shape as downloadApproveStockPunchExcel/Pdf — the backend reuses
// getApprovedStockPunchListPunchWise and applies the same current-month date
// default when neither bound is supplied.
export const downloadItemWiseStockPunchExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock-punch/reports/item-wise-stock-punch-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadItemWiseStockPunchPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/stock-punch/reports/item-wise-stock-punch-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Dashboard — Total Complaints — Excel + PDF.
// Forwards `year_name`, optional `status`/`fromDate`/`toDate`. Backend
// reuses existing `getAllComplaints` via fake-response capture; defaults
// the date range to the current month when neither bound nor `year_name`
// is supplied.
export const downloadTotalComplaintsExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/total-complaints-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadTotalComplaintsPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/total-complaints-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// View Complaint screen — single complaint detail download.
// Reuses backend `getComplaintsDetailsById` data via a fake-response
// capture, so the report mirrors the on-screen view exactly. No new
// SQL path means no UI/report drift.
export const downloadSingleComplaintPdf = async (complaintId) => {
  try {
    const response = await customApi.get(
      `/api/contractor/complaints/reports/single-complaint-pdf/${complaintId}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadSingleComplaintExcel = async (complaintId) => {
  try {
    const response = await customApi.get(
      `/api/contractor/complaints/reports/single-complaint-excel/${complaintId}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// All Complaints screen, three-dot action menu. Both reports open with the
// same top block as the View Complaint Report and then carry only their own
// summary boxes.
export const downloadComplaintFundStockPdf = async (complaintId) => {
  try {
    const response = await customApi.get(
      `/api/contractor/complaints/reports/complaint-fund-stock-pdf/${complaintId}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadComplaintManpowerPdf = async (complaintId) => {
  try {
    const response = await customApi.get(
      `/api/contractor/complaints/reports/complaint-manpower-pdf/${complaintId}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved → Un-Assign tab — PDF + Excel report download. Backend reuses
// getAllApprovedUnAssignComplaints via fake-response capture, so the
// downloaded rows match the listing exactly. All filter params (date,
// regional office, sales area, outlet, search, etc.) flow through unchanged.
export const downloadApprovedUnAssignExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/approved-unassign-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApprovedUnAssignPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/approved-unassign-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Approved → Assign tab — PDF + Excel download. Mirrors the Un-Assign
// helpers above; backend reuses getAllApprovedAssignComplaints via
// fake-response capture so rows match the listing exactly.
export const downloadApprovedAssignExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/approved-assign-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadApprovedAssignPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/approved-assign-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Request tab (tab=0) — PDF + Excel download. Mirrors the Un-Assign /
// Assign helpers above; backend reuses getAllRequestedComplaints via
// fake-response capture so rows match the listing exactly. All filter
// params (date, company, RO, SA, outlet, order_by, created_by, search)
// flow through unchanged.
export const downloadRequestedComplaintsExcel = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/requested-complaints-excel${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadRequestedComplaintsPdf = async (params = {}) => {
  try {
    const filtered = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const queryString = new URLSearchParams(filtered).toString();
    const response = await customApi.get(
      `/api/contractor/complaints/reports/requested-complaints-pdf${
        queryString ? `?${queryString}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Supplier Items (Corporation Mgmt → Supplier Mgmt → Approved → View) —
// Excel + PDF. Reuses existing `getSupplierItems` SQL via fake-response
// capture. Default date range on the backend = current financial year
// (Apr 1 → Mar 31) when neither bound is supplied.
export const downloadSupplierItemsExcel = async (
  supplierId,
  fromDate,
  toDate,
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/suppliers/reports/supplier-items-excel/${supplierId}${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const downloadSupplierItemsPdf = async (
  supplierId,
  fromDate,
  toDate,
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/suppliers/reports/supplier-items-pdf/${supplierId}${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// All-suppliers Bill-Wise report (Supplier Management → Reports tab).
// format: "pdf" (default) | "excel". Returns the raw blob axios response.
export const downloadSuppliersBillWiseReport = async (
  fromDate,
  toDate,
  format = "pdf",
) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/suppliers/reports/suppliers-bill-wise${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Pending Payment Report — bill-wise across suppliers, only bills with
// outstanding > 0. Same filters shape as getAllSuppliers (supplier_name,
// gst_number, state, city, pincode, fromDate, toDate) so the report matches
// the on-screen filter selection. format: "pdf" | "excel". Returns the raw
// blob axios response — caller does the object-URL download.
export const downloadPendingPaymentReport = async (
  filters = {},
  format = "pdf",
) => {
  try {
    const params = new URLSearchParams();
    const {
      supplier_name = "",
      gst_number = "",
      state = "",
      city = "",
      pincode = "",
      fromDate = "",
      toDate = "",
    } = filters;
    if (supplier_name) params.append("supplier_name", supplier_name);
    if (gst_number) params.append("gst_number", gst_number);
    if (state) params.append("state", state);
    if (city) params.append("city", city);
    if (pincode) params.append("pincode", pincode);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/suppliers/reports/pending-payment${qs ? `?${qs}` : ""}`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Supplier Purchase Report (monthly purchase register) — same filter/blob
// contract as downloadPendingPaymentReport, different endpoint.
export const downloadSupplierPurchaseReport = async (
  filters = {},
  format = "pdf",
) => {
  try {
    const params = new URLSearchParams();
    const {
      supplier_name = "",
      gst_number = "",
      state = "",
      city = "",
      pincode = "",
      fromDate = "",
      toDate = "",
    } = filters;
    if (supplier_name) params.append("supplier_name", supplier_name);
    if (gst_number) params.append("gst_number", gst_number);
    if (state) params.append("state", state);
    if (city) params.append("city", city);
    if (pincode) params.append("pincode", pincode);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (format === "excel") params.append("format", "excel");
    const qs = params.toString();
    const response = await customApi.get(
      `/api/contractor/suppliers/reports/supplier-purchase${
        qs ? `?${qs}` : ""
      }`,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getSupplierTransactions = async (
  supplierId,
  pageSize,
  pageNo,
  fromDate,
  toDate,
  transactionType,
) => {
  try {
    const params = new URLSearchParams();
    if (pageSize) params.append("pageSize", pageSize);
    if (pageNo) params.append("pageNo", pageNo);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (transactionType) params.append("transactionType", transactionType);
    const { data } = await customApi.get(
      `/api/contractor/fund/reports/get-supplier-transactions/${supplierId}?${params.toString()}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// FINANCIAL YEAR
export const postFinancialYears = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/financial-year/create-financial-year`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleFinancialYearsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/financial-year/fetch-financial-year-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateFinancialYears = async (id, values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/master-data/financial-year/update-financial-year-by-id/${id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteFinancialYearsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/financial-year/delete-financial-year-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// TAX
export const getAllTaxManagement = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/tax/get-all-saved-gst-masters?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postTaxManagement = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/tax/save-gst-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateTaxManagement = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/tax/update-gst-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteTaxManagementById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/tax/delete-gst-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleTaxManagementById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/tax/get-saved-gst-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// BILL NO. FORMAT
export const postBillNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bill-format/generate-invoice-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllBillNoFormat = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/bill-format/get-all-generate-invoice-formats?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateBillNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/bill-format/update-invoice-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleBillNoFormatById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/bill-format/get-invoice-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteBillNoFormatById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/bill-format/delete-invoice-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateBillFormateStatus = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/master-data/bill-format/update-invoice-number-format-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Employee NO. FORMAT
export const postEmployeeNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/employee-format/generate-employee-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllEmployeeNoFormat = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/employee-format/get-all-employee-number-formats?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateEmployeeNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/employee-format/update-employee-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleEmployeeNoFormatById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/employee-format/get-employee-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteEmployeeNoFormatById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/employee-format/delete-employee-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateEmployeeFormateStatus = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/master-data/employee-format/update-employee-number-format-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Client NO. FORMAT
export const postClientNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/client-vendor-format/generate-client-vendor-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllClientNoFormat = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/client-vendor-format/get-all-client-vendor-number-formats?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateClientNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/client-vendor-format/update-client-vendor-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleClientNoFormatById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/client-vendor-format/get-client-vendor-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteClientNoFormatById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/client-vendor-format/delete-client-vendor-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateClientFormateStatus = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/master-data/client-vendor-format/update-client-vendor-number-format-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Item NO. FORMAT
export const postItemNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/item-format/generate-item-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllItemNoFormat = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/item-format/get-all-item-number-formats?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateItemNoFormat = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/item-format/update-item-number-format`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleItemNoFormatById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/item-format/get-item-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteItemNoFormatById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/item-format/delete-item-number-format-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateItemFormateStatus = async (values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/master-data/item-format/update-item-number-format-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// PAYMENT METHODS
export const postPaymentMethod = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/payment-method/add-payment-method`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updatePaymentMethod = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/payment-method/update-payment-method`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deletePaymentMethodById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/master-data/payment-method/delete-payment-methods/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSinglePaymentMethodById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/master-data/payment-method/get-single-payment-method-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// ADD BALANCE
export const addWalletBalance = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/master-data/add-balance/add-wallet-amount`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// FEEDBACK AND SUGGESTIONS

export const postFeedbackSuggestion = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/feedback-suggestion/create-feedback-and-complaint`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllFeedbackSuggestion = async (
  search,
  pageSize,
  pageNo,
  feedbackSuggestionId,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/feedback-suggestion/get-all-feedback-and-complaint?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&status=${
        feedbackSuggestionId || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getFeedbackSuggestionById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/feedback-suggestion/get-feedback-and-complaint/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteFeedbackSuggestionById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/feedback-suggestion/delete-feedback-and-complaint/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postResponse = async (id, values) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/feedback-suggestion/add-response/${id}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// API'S FOR IMPORT MODULE **************

// upload company using csv file
export const uploadCompany = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/company/import-companies`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// upload complaint using csv file
export const uploadComplaint = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/complaints/import-complaint`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const uploadBulkComplaints = async (formData) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/complaints/bulk-import-complaint`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// upload outlet using csv file
export const uploadOutlets = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/fuel-station/import-outlet`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// **************PREVIOUS API'S ****************

export const getAllUnitMasterForDropdown = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-unit-data-list`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllBrandName = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-brand-markdown`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSubCategory = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-sub-category?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllAssignedAssets = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-assigned-assets`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAssetsTimelineById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-assets-timeline-history/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const reactiveMeasurementsById = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/reactive-to-discard-measurements`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeForBilling = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-all-complaint-types-in-billing?status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateHardCopiesInMeasurements = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-pi-attachment-complaint`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletforfilter = async (
  status,
  po_id,
  ro_id,
  sale_area_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-outlet-filters?status=${status || ""}&&po_id=${
        po_id || ""
      }&&ro_id=${ro_id || ""}&&sale_area_id=${sale_area_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeforfilter = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-all-complaint-types-filters?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllAreaManagerforfilter = async (
  status,
  po_id,
  ro_id,
  sale_area_id,
  outlet_id,
  company_id,
  complaint_for,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-area-manager?status=${status || ""}&&po_id=${
        po_id || ""
      }&&ro_id=${ro_id || ""}&&sale_area_id=${sale_area_id || ""}&&outlet_id=${
        outlet_id || ""
      }&&company_id=${company_id || ""}&&complaint_for=${complaint_for || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPoList = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-po-filters?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRoList = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-ro-filters?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllCompanyNAme = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-in-pi?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPoListInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-po-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRoListInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-ro-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillNumber = async (
  status,
  ro_id,
  po_id,
  invoice,
  sale_area_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-bill-from-proforma?status=${
        status || ""
      }&&ro_id=${ro_id || ""}&&po_id=${po_id || ""}&&invoice=${
        invoice || ""
      }&&sale_area_id=${sale_area_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const discardPerformaById = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/discard-proforma-invoice/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllSaListInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-all-sales-area-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletForPerforma = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-outlet-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeListInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-all-complaint-types-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllFinacialYear = async (
  status,
  ro_id,
  po_id,
  sale_area_id,
  bill_number,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-financial-year-from-proforma?status=${
        status || ""
      }&&ro_id=${ro_id || ""}&&po_id=${po_id || ""}&&sale_area_id=${
        sale_area_id || ""
      }&&bill_number=${bill_number || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDetailPerforma = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/performa-invoice/get-single-proforma-invoice/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDetailsOfFinalMergeToPI = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-performa/get-merged-proforma-invoice/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllDiscardMeasurementDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-discard-measurements-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateMeasurements = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/measurement/update-measurement-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComapnyDataForBillingFrom = async (isDropdown) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-my-company-list?isDropdown=${isDropdown || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllItemsOnMeasurementId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-items-on-measurement-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const fetchMeasurementDatabyPoAndMeasurementId = async (
  po_id,
  measurement_ids,
) => {
  const values = { po_id, measurement_ids };

  try {
    const { data } = await customApi.get(
      `/api/contractor/get-measurements-detail-po?po_id=${
        po_id || ""
      }&&measurement_ids=${measurement_ids || ""}`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateProformaInvoice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/performa-invoice/update-proforma-invoice-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postProformaInvoice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/performa-invoice/generate-proforma-invoice`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleTaxesById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-tax-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleMessages = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-sender-messages/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getMessagesMarkRead = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/sender-messages-mark-read/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingType = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-billing-types?search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateTaxes = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-tax-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postTaxes = async (values) => {
  try {
    const { data } = await customApi.post(`/api/contractor/create-tax`, values);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const discardfinalInvoices = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/discard-invoice/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getInvoiceDetails = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-single-invoice-details/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllFinancialYearListInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-financial-year-from-proforma?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingFrom = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/ro-to-billing-from-company?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};
export const getAllBillingTo = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/from-billing-to-company?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const fetchPerformaListing = async (measurement_ids) => {
  const value = { id: measurement_ids };
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/invoice/get-all-pi-listing`,
      value,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateInvoice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/invoice/update-invoice-data`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postInvoice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/invoice/create-invoice-data`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllMeasurements = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-measurements?search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteMeasurementsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-measurements-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPoListInMergeInvoice = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-po-for-invoices?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRoListInMergeInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-ro-for-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllSalesAreaInInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-sales-area-for-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeListInInvoice = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-all-complaint-types-for-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingFromList = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-billing_from-company-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingToListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-all-billing-to-company-invoice?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postMergeInvoice = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/merged-invoice/merge-invoice`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const discardFinalMergedInvoices = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/discard-merged-invoice/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getDetailsOfMergedInvoice = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/merged-invoice/get-merged-invoice-by-id/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const discardfinalMergedPI = async (value) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/discard-merged-pi`,
      value,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postMergePi = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/merged-performa/merged-proforma-invoice`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getInvoicesDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-received-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllInvoicesData = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-invoice-data-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updatePaymentRecieved = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/payment-received/update-payment-received-by-id`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPaymentRecieved = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/payments/add-payment-to-invoice`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// Voucher / advice copy for a payment; returns { status, path, name }.
export const uploadPaymentAttachment = async (file) => {
  try {
    const formData = new FormData();
    formData.append("attachment", file);
    const { data } = await customApi.post(
      `/api/contractor/billing/payments/upload-payment-attachment`,
      formData,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};
export const getPayementRecievedDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-received-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getPaymentVoucher = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-history?id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllProcessPaymentPaid = async (
  status,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-paid?status=${status || ""}&&search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRoListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-ro-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRetentionIdListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-retention-id-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const ApproveOrReeligibleRetentions = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-payment-retention-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPONumber = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-po-for-payment-retention?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getPaymentPaidDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-paid-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const otpVerifyInPaymentPaid = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/otp-verify-in-payment-paid`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPaidPaymentListing = async (
  pageSize,
  pageNo,
  search,
  ro_id,
  area_manager_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-via-invoice?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&ro=${
        ro_id || ""
      }&&manager_id=${area_manager_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRoInPaymentPaid = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-ro-in-paid-payment`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllAreaManagerInPaymentPaid = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-area-manager-in-paid-payment`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPaymentPaid = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/payment-paid`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const resendOTPInPaymentPaid = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/resend-otp-in-payment-paid`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getPODetailsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-po-details-in-ro-payments-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteProformaInvoiceById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-proforma-invoice/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPiToMerge = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/merge-pi-to-invoice`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesAreaListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-sales-area-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-outlet-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintTypeListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-complaint-type-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingFromListing = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-billing-from-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllBillingToListingforFilter = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);

    const { data } = await customApi.get(
      `/api/contractor/get-billing-to-for-dropdown?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const approveEligibleRetention = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/retention/approve-payment-retention`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const approveRetentionAmount = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/retention/update-payment-amount-retention`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getInvoiceDetailForRetention = async (id, pdf) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/retention/get-payment-retention-by-id/${id}?pdf=${
        pdf || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postRetentionMoney = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/retention/update-payment-retention`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const discardRetentions = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/retention/discard-payment-retention/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllTaxes = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-taxes?search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteTaxesById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-tax-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getMeasurementsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-measurements-detail-by-po/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintIdList = async (includePendingPunch) => {
  try {
    // includePendingPunch: approve-punch screens set this so complaints that
    // were resolved with punches still pending stay selectable.
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-list-dropdown${includePendingPunch ? "?include_pending_punch=1" : ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getStockRequestDetailsOnItemId = async (id, user_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-stock-details-on-item-id/${id}/${user_id || 0}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getUserDetailsByComplaintId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-details-by-complaint-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAreaManagerOfUser = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-area-manager-of-user/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteMessageById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-message/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllDealerContacts = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-dealer-users?search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSendMessagesById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-message-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.message || error?.message,
    };
  }
};
export const updateMessages = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-message`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintList = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaint-list`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletList = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-outlet-list`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllAreaManager = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-managers-users`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllComplaintIdListMangerWise = async (
  id,
  role,
  includePendingPunch,
) => {
  try {
    const params = [];
    if (role) params.push(`role=${encodeURIComponent(role)}`);
    // Approve-punch screens: keep complaints with punches still pending
    // approval selectable even after the complaint is resolved.
    if (includePendingPunch) params.push("include_pending_punch=1");
    const url = `/api/contractor/get-area-manager-to-complaints/${id}${params.length ? `?${params.join("&")}` : ""}`;
    const { data } = await customApi.get(url);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintIdListOfficeWise = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-regional-office-to-complaints/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getItemPriceDetails = async (id, userId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-approve-item-price/${id}/${userId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postAddFunds = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-fund-user-wallet`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllApprovedCashRequest = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-approved-cash-request-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleRequestCashById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-cash-requested-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateRequestCash = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-cash-requested-detail`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postRequestCash = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/request-cash`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleExpenseCategoryById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-expense-category/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateExpenseCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-expense-category`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postExpenseCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-expense-category`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllExpenseCategory = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-expense-category?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteExpenseCategoryById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-expense-category/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleExpensesCashById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-expense-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllExpenseCategoryForDropdown = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-expense-category-for-dropdown`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPaymentMethodForDropdown = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-payment-methods-for-dropdown`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateExpensesCash = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-expense-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postExpensesCash = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-expense-cash`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalOrderBy = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-regional-order-by`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSupervisors = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-all-supervisors`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllEndUsers = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-all-end_users`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getComplaintsFreeUsersCount = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-free-end-users-count`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getManagerFreeTeamMembers = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-manager-free-team-members/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postReactiveRejectFundRequestet = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/reactive-reject-fund-requestet/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPreviousItemsList = async (id, transferDate) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-fund-request-items-by-user-id/${id}${
        transferDate ? `?transfer_date=${transferDate}` : ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getPreviousFundRequestById = async (id, requestId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-fund-request-details-by-request-for/${id}/${requestId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// export const getUserFinancialSummary = async (userId) => {
//   try {
//     const { data } = await customApi.get(
//       `/api/contractor/get-user-financial-summary/${userId}`
//     );
//     return data;
//   } catch (error) {
//     return {
//       status: false,
//       message: error.response?.data.message || error.message,
//     };
//   }
// };

export const getUserFinancialSummary = async (userId, params = {}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-financial-summary/${userId}`,
      {
        params: {
          ...params,
        },
      },
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Item-wise Stock + Fund details for the User "View Account" screen.
// Query params { fromDate, toDate } are passed as raw YYYY-MM-DD (the page's
// own state values) — do NOT reformat to DD-MM-YYYY for this JSON endpoint.
export const getUserItemwiseDetails = async (userId, params = {}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-itemwise-details/${userId}`,
      {
        params: {
          ...params,
        },
      },
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

export const getPreviousStockRequestById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-stock-request-details-by-request-for/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postTransferFundRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/transfer-fund`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteStockRequestById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-stock-request/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Quotation Api's
export const getAllQuotation = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/quotations/get-quotation?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postPaymentPaidInRo = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-ro-payment-paid`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// post api for create ro payement
export const PostPaymentForRo = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-ro-payment-paid`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSendByEmailQuotation = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/quotation-send-by-email`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//  all office Expense Api's
export const getAllEmployeeComplaints = async (
  pageSize,
  pageNo,
  search,
  formattedDate,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-employee-history-with-complaints?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&month=${
        formattedDate || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// area manager

export const getAllAreaManagerTransactionById = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-area-manager-transactions?id=${id}&&search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalOfficeTransactionById = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-transactions-ro-by-id?id=${id}&&search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all purchase order transactions
export const getAllPOTransactionById = async (search, pageSize, pageNo, id) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-transactions-po-by-id?id=${id}&&search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllAreaManagerTransaction = async (
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-all-area-manager-transactions?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all regional office transactions
export const getAllROTransactions = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-transactions-balance-of-ro?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all purchase order transactions
export const getAllPOTransactions = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi(
      `/api/contractor/get-transactions-balance-of-po?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// setting
export const getAllAreaManagerList = async (
  search,
  pageSize,
  pageNo,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-manager-list-with-total-free-end-users?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postPaymentSetting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/create-payment-setting`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPromotionalManagerSetting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-promotional-manager`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updatePaymentSetting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-payment-setting`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updatePromotionalSetting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-promotional-manager`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getPromotionalSettingById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-promotional-manager/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getPaymentsettingById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-payment-setting-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPaymentsetting = async (
  search,
  pageSize,
  pageNo,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-payment-setting?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPromotionalsetting = async (
  search,
  pageSize,
  pageNo,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-promotional-manager?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&status=${
        status || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all discards complaints in bill management
export const getAllDiscardsComplains = async (pageSize, pageNo, search) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-discard-measurements?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Api for view of pending fund in Site Inspection
export const getPendingFundInSiteInspection = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-pending-site-complaints-for-funds-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Api for view of  partial fund in Site Inspection
export const getPartialFundInSiteInspection = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-partial-site-complaints-for-funds-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Api for view of  approve fund in Site Inspection
export const getApprovedFundInSiteInspection = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-approved-site-complaints-for-funds-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Api for view of partial site expense request
export const getPartialSiteExpenseRequestData = async (outlet_id, month) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-site-inspections-partial-by-id/${
        outlet_id || null
      }/${month}
        `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postFundPunchApproveBySite = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/approve-site-inspection-for-fund`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for Listing of payment process in regional office
export const getAllProcessPaymentForRO = async (
  status,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-ro-payment-paid?status=${status || ""}&&search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllPurchaseOrderListingInPayment = async (
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-po-details-in-ro-payments?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRegionalOfficeListing = async (
  pageSize,
  pageNo,
  search,
  ro_id,
  po_id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-via-invoice-ro?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&ro=${
        ro_id || ""
      }&&po_number=${po_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// paid invoices

export const getAllPoInPaymentPaid = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-po-in-paid-payment`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for invoices details in payment paid module
export const getInvoicesDetailsPaymentPaid = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-by-id?complaint_id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for details of invoice which are reieved payment for retention money
export const getDetailsOfPaymentPaidForRO = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-ro-payment-paid-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for view Process To Measurement
export const getDetailsForProcessToMeasurement = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-attachment-and-inspection-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for pending fund inspection
export const getPendingFundRequestInSite = async (
  sales_area_id,
  regional_office_id,
  outlet_id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-pending-site-complaints-for-funds?outlet_id=${
        outlet_id || ""
      }&&regional_office_id=${regional_office_id || ""}&&sales_area_id=${
        sales_area_id || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for partial fund inspection
export const getPartialFundRequestInSite = async (
  sales_area_id,
  regional_office_id,
  outlet_id,
  pageSize,
  pageNo,
  search,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-partial-site-complaints-for-funds?outlet_id=${
        outlet_id || ""
      }&&regional_office_id=${regional_office_id || ""}&&sales_area_id=${
        sales_area_id || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get api for approved fund inspection
export const getApprovedFundRequestInSite = async (params) => {
  try {
    const queryParams = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/get-approved-site-complaints-for-funds?${queryParams}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Company Api's

export const getEnergyCompanydata = async ({
  energy_company_id,
  energy_company_name,
  status,
  fromDate,
  toDate,
} = {}) => {
  try {
    // Build query parameters object
    const params = {};

    if (energy_company_id) {
      params.energy_company_id = energy_company_id;
    }
    if (energy_company_name) {
      params.energy_company_name = energy_company_name;
    }

    if (status) {
      params.status = status;
    }
    if (fromDate) {
      params.fromDate = fromDate;
    }
    if (toDate) {
      params.toDate = toDate;
    }

    // Convert params to query string
    const queryString = new URLSearchParams(params).toString();

    const { data } = await customApi.get(
      `/api/contractor/get-active-energy-companies${queryString ? `?${queryString}` : ""}`,
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// All Outlet On SaleArea Id Api's
export const getOutletOnSaId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-outlet-by-sale-area/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSignleBillingTypeById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-billing-types/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postBillingType = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/create-billing-types`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateBillingType = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-billing-types`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteBillingTypeById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-billing-type/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Proforma Invoice Api's
export const getAllProformaInvoice = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-proforma-invoices?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleProformaInvoiceById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-proforma-invoice/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Invoice Api's
export const getAllInvoice = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-invoice-data?search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleInvoiceById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-invoice-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteInvoiceById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-invoice-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// from company list used in purchase order
export const getFromCompanyList = async (isDropdown) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/all-sale-companies?isDropdown=${isDropdown || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// to company list used in purchase order
export const getToCompanyList = async (isDropdown) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-my-company-list?isDropdown=${isDropdown || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFilterDropdown = async (payload) => {
  try {
    const { data } = await customApi.post(
      `api/contractor/company/my-company/get-my-company-list-id`,
      payload,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// download uploaded csv and sample csv file in purchase order
export const downloadCsvFile = async () => {
  try {
    const response = await customApi.get(
      `/api/contractor/download-csv-purchase-order-items`,
    );
    return response;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllBrandForStockPunch = async (itemId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-brands-by-item-id/${itemId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllItemMasterForStockPunch = async (userId, punchDate) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-stock-items-lists/${userId}${
        punchDate ? `?punch_date=${punchDate}` : ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get all brand name in item master

// All Security Deposit Api's
export const getAllSecurityDeposit = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-security-money-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postSecurityDeposit = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/add-security-money`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateSecurityDeposit = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-security-money-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleSecurityDepositById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-security-money-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteSecurityDepositById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-security-money-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Product Details Api's
export const getSingleProductDetailsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/product-detail/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteProductDetailsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-product/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllBrand = async ({ search, pageSize, pageNo, isDropdown }) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/item-master/get-all-brand?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&isDropdown=${
        isDropdown || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postBrand = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/item-master/create-brand`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateBrand = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/item-master/update-brand`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleBrandById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/item-master/get-brand-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteBrandById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/item-master/delete-brand/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Sub Category Api's

export const createSubCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/item-master/add-sub-category`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const updateSubCategory = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/item-master/edit-sub-category`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleSubCategoryById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/item-master/get-sub-category-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteSubCategoryById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/item-master/delete-sub-category/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Sales Area Api's
export const getAllSalesArea = async ({
  search = "",
  pageSize = "",
  pageNo = "",
  energy_company_id = "",
  zone_id = "",
  ro_id = "",
  sales_area_id = "",

  status = "",
  fromDate = "",
  toDate = "",
}) => {
  try {
    // const queryParams = QUERY_PARAMS(params);
    const params = {
      search: search || undefined,
      pageSize: pageSize || undefined,
      pageNo: pageNo || undefined,
      energy_company_id: energy_company_id || undefined,
      zone_id: zone_id || undefined,
      ro_id: ro_id || undefined,
      sales_area_id: sales_area_id || undefined,
      status: status || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    };
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined),
    );

    const queryString = new URLSearchParams(filteredParams).toString();

    const { data } = await customApi.get(
      `/api/contractor/sales-area?${queryString}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Sales Area Api's for office expense inspection
export const getAllSalesAreaForOfficeInspection = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-sales-area-list`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllActiveSalesArea = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/active-sales-area`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Office Inspection Api's
export const getAllOutletAndSaleAreaList = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-outlet-and-sale-area-list/${id}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintsOnOutlet = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaints-on-outlet/${id}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllPendingComplaints = async (search, pageSize, pageNo, id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-pending-used-items-on-complaint/${id}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postApprovedUsedItems = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/approved-used-items-on-complaint/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllApprovedComplaints = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-approved-used-items-on-complaint/${id}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postAssignComplaint = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assign-complaint-module-to-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postAssignMultipleComplaint = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assign-multiple-complaint-module-to-user`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletForDropdown = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-outlet-for-dropdown`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Office Inspection Item Stock Api's
export const getOfficeInspectionItemsStock = async (
  search,
  pageSize,
  pageNo,
  id,
  status,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-punch-stocks/${id}/${status}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleOfficeInspectionItemsStock = async (id, status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-punch-stocks-details/${id}/${status}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postOfficeInspectionItemsStock = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/approved-punch-stocks-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Idle Assets Api's
export const getAllIdleAssets = async ({
  search,
  pageSize,
  pageNo,
  isDropdown,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-idle-asset-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&isDropdown=${
        isDropdown || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Asset repair require Api's
export const getAllAssetRepairRequire = async ({
  search,
  pageSize,
  pageNo,
  isDropdown,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-repair-requested-asset-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&isDropdown=${
        isDropdown || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postAssetRepairRequire = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/request-asset-repair`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateAssetRepairRequire = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-repair-requested-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postMarkRequestViewed = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/mark-request-viewed/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleAssetRepairRequireById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-repair-requested-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteAssetRepairRequireById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-repair-requested-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Work Images  Api's
export const getAllWorkImages = async ({
  search,
  pageSize,
  pageNo,
  isDropdown,
  status,
}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-uploaded-complaint-images?status=${
        status || ""
      }&&search=${search || ""}&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }&&isDropdown=${isDropdown || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleWorkImagesById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-uploaded-complaint-images/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postWorkImages = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/upload-complaint-images`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateWorkImages = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-uploaded-complaint-images`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteWorkImagesById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-uploaded-complaint-images/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const approveRejectWorkImageById = async (status, workImageId) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/approve-reject-complaint-images-by-status?status=${
        status || ""
      }&&id=${workImageId || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSingleComplaintDetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-complaint-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFreeEndUsers = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-end-user-details`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postEarthingTestingEarthPitReport = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/earth-pit-reports`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const changeStatusEarthingTesting = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/change-earthing-testing-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Gst Type's Api's

export const getFundRequestDetailsOnItemId = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-fund-request-details-on-item-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFundRequest4LowPriceOnItemId = async (
  id,
  category,
  supplierId,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-fund-request-4-low-price/${id}/${category}/${supplierId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getFundRequest3BrandNameByItem = async (category, itemName) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-price-by-brand?category=${category}&&itemName=${itemName}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getFundRequest4SubLowPriceOnItemId = async (id, supplierId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-last-three-prev-price-by-supplier/${id}/${supplierId}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//get item price in create stock punch transfer
export const getItemPriceDetailsStockPunch = async (id, request_by) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/stock-punch-get-approve-item-price/${id}/${request_by}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const postImportBankList = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/import-bank-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Stocks Api's
export const getAllStocks = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-items-stocks-report?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postTransferStock = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/transfer-stock`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleStockById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-item-stock-distribution-report/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Level Wise Api's
export const getLevelOne = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-logged-user-details-and-type`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getUserOnRoleWise = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-on-role-level-wise/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postUserOnRoleWise = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/save-user-hierarchy-level-wise`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Food Expenses Api's
export const getFoodExpenses = async () => {
  try {
    const { data } = await customApi.get(`/api/contractor/get-food-expense`);
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postPunchFoodExpenses = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/punch-food-expense`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Pi To Merge Api's
export const getAllPiOnPoNumber = async (search, pageSize, pageNo, id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-pi-on-po-number/${id}?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Fund Management Api's
export const getUserWalletBalance = async (id, user_type) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-wallet-balance?user_id=${id || ""}&&user_type=${user_type || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getUserTransactionMonthly = async (
  id,
  date,
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-transaction-monthly?user_id=${
        id || ""
      }&&year_month=${date || ""}&&search=${search || ""}&&pageSize=${
        pageSize || ""
      }&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getCashRequestStatusTracked = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-cash-request-status-tracked?user_id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getUserTransactionHistory = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-transaction-history?user_id=${id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getUserAllTransactionReport = async (
  search,
  pageSize,
  pageNo,
  id,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/user-all-transaction-report?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&user_id=${
        id || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Request Cash Api's
export const getAllRequestCash = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-logged-user-cash-requested?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteRequestCashById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-cash-request/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRejectedCashRequest = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-rejected-cash-request-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Expense Cash Api's
export const getAllExpensesCash = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-logged-user-expenses?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const deleteExpensesCashById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-expense-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Request Expense Api's
export const getAllRequestExpense = async (
  search,
  pageSize,
  pageNo,
  expenseStatus,
  expenseDate,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-requested-expenses?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}&&expenseStatus=${
        expenseStatus || ""
      }&&expenseDate=${expenseDate || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRequestCashExpense = async (
  search,
  pageSize,
  pageNo,
  cashRequestStatus,
  cashRequestDate,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-cash-requested-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${
        pageNo || ""
      }&&cashRequestStatus=${cashRequestStatus || ""}&&cashRequestDate=${
        cashRequestDate || ""
      }`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postApproveRejectExpense = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/approve-reject-expense-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postApproveRejectRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-cash-request-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// All Site Items/Goods Api's
export const getAllSiteItemsGoods = async (search, pageSize, pageNo) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-request-item-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postSiteItemsGoods = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/request-item`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const updateSiteItemsGoods = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-requested-item-details`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getSingleSiteItemsGoodsById = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-single-request-item-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const deleteSiteItemsGoodsById = async (id) => {
  try {
    const { data } = await customApi.delete(
      `/api/contractor/delete-request-item/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const postApproveRejectSiteItemsGoodsRequest = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/update-requested-item-status`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllApprovedSiteItemsGoods = async (
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-approved-items-request-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllRejectedSiteItemsGoods = async (
  search,
  pageSize,
  pageNo,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-rejected-items-request-list?search=${
        search || ""
      }&&pageSize=${pageSize || ""}&&pageNo=${pageNo || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// complaints filter api's

export const getAllCompanyfilterInMeasurement = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-companies-in-billing?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};


export const getAllOrderByIdNew = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-order-by-id-new?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllOutletByIdNew = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-outlet-by-id-new?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllOutletByIdForOfficeInspection = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-outlet?status=${status ?? ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all outlet data in site Inspection
export const getAllOutletByIdForSiteInspection = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-outlet?status=${status ?? ""}&&siteFor=1`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all outlet data in site Inspection for fund
export const getAllOutletByIdForFundInSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-outlet-office-by-id-for-fund?status=${
        status ?? ""
      }&&siteFor=1`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all outlet data in site Inspection for Fund
export const getAllOutletForFundInSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-outlet?status=${status ?? ""}&&siteFor=1`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//post api for assign employee in site inspection for stock
export const postAssignEmployee = async (values) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/assign-complaints-in-site-inspection`,
      values,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

//post api for assign employee in site inspection for fund

export const getAllRegionalByIdNew = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-regional-by-id-new?status=${status || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllRegionalByIdForOffice = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-regional-list?status=${status ?? ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Regional By Id For Site
export const getAllRegionalForFundInSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-regional-office-expense-by-id-for-fund?status=${
        status ?? ""
      }&&siteFor=1 `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Regional By Id For Site for fund
export const getAllRegionalByIdForSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-regional-list?status=${
        status ?? ""
      }&&siteFor=1 `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get Regional By Id For Site for fund
export const getAllRegionalByIdForFundInSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-regional-office-expense-by-id-for-fund?status=${
        status ?? ""
      }&&siteFor=1 `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllSalesByIdNew = async (status, sales_area_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-sales-by-id-new?status=${status || ""}&&sales_area_id=${sales_area_id || ""}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
// get All All Complaint list in performa invoice based on ro
export const getAllcomplaint = async (status, ro_id, po_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-ro-based-on-complaint?status=${
        status || ""
      }&&ro_id=${ro_id || ""}&&po_id=${po_id || ""} `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get All All Complaint list in performa invoice based on ro
export const getAllcomplaintInvoice = async (status, ro_id, po_id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-bill-number-from-proforma?status=${
        status || ""
      }&&ro_id=${ro_id || ""}&&po_id=${po_id || ""} `,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all sales area for office inspection
export const getAllSalesByIdForOfficeInspection = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-sales-area?status=${status}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all sales area for Site inspection
export const getAllSalesByIdForSiteInspection = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-office-sales-area?status=${status ?? ""}&&siteFor=1`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// get all sales area for Site inspection
export const getAllSalesForFundInSite = async (status) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-sales-area-office-by-id-for-fund?status=${
        status ?? ""
      }&&siteFor=1`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const ReactivateSupplierRejected = async (id) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/suppliers/reactive-suuplier-by-id/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getSupplierHistoryOfToday = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-today-history-by-supplier/${id}`,
    );

    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAreaManagerSupervisor = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-user-to-supervisor-or-manager/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};
export const getAllComplaintType = async () => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-all-complaint-types`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getAllItemMasteroncomplaintType = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-item-master-by-complaint-type/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const ReactivateFuelStationRejected = async (id) => {
  try {
    const { data } = await customApi.put(
      `/api/contractor/fuel-station/get-reactive-outlet/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const checksamesupplierfundonsameday = async (
  supplier_id,
  date,
  created_for,
) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/fund/fund-request/check-same-supplier-fund-on-same-day/${supplier_id}/${date}/${created_for}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

export const getpunchrequestitemdetails = async (id) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/get-requested-expense-item-details/${id}`,
    );
    return data;
  } catch (error) {
    return {
      status: false,
      message: error.response?.data.message || error.message,
    };
  }
};

// Who did what on a request (raised / approved / rejected / transferred / punched ...)
export const getFundRequestHistory = async (id) => {
  try {
    const { data } = await customApi.get(`/api/contractor/fund/fund-request/get-request-history/${id}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};
export const getStockRequestHistory = async (id) => {
  try {
    const { data } = await customApi.get(`/api/contractor/stock/stock-request/get-request-history/${id}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// One user's fund-request steps + punches for a month (All Expense Request screen)
// Remark history: correct a stage's ({ source: "timeline", id }) or a
// punch's ({ source: "punch", id }) remark; the old text is kept.
export const updateFundRemark = async (values) => {
  try {
    const { data } = await customApi.put(`/api/contractor/fund/fund-request/update-remark`, values);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Same for a stock request: { source: "timeline" | "punch", id, remark }.
export const updateStockRemark = async (values) => {
  try {
    const { data } = await customApi.put(`/api/contractor/stock/stock-request/update-remark`, values);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data?.message || error.message };
  }
};

// Remarks of the request(s) one punch row drew from — an employee's punches on
// one complaint on one day (punch View / Approve). type "fund" | "stock".
export const getPunchRequestRemarks = async (type, { punchId, pending, userId, complaintId, date }) => {
  try {
    const base = type === "stock" ? "stock/stock-punch" : "fund/expense-punch";
    const { data } = await customApi.get(
      `/api/contractor/${base}/punch-request-remarks?${QUERY_PARAMS(
        punchId
          ? { punch_id: punchId, pending: pending ? 1 : undefined }
          : { user_id: userId, complaint_id: complaintId, punch_date: date },
      )}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Remarks of an employee's requests still open for punching (any month).
// type "fund" (Create Expense Punch) | "stock" (Create Stock Punch).
export const getOpenRequestRemarks = async (type, userId) => {
  try {
    const base = type === "stock" ? "stock/stock-punch" : "fund/expense-punch";
    const { data } = await customApi.get(`/api/contractor/${base}/open-request-remarks/${userId}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

export const getUserFundRequestHistory = async (userId, month, year) => {
  try {
    const { data } = await customApi.get(`/api/contractor/fund/fund-request/get-user-request-history/${userId}?month=${month}&year=${year}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

export const getUserStockRequestHistory = async (userId, month, year) => {
  try {
    const { data } = await customApi.get(`/api/contractor/stock/stock-request/get-user-request-history/${userId}?month=${month}&year=${year}`);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// ---- Sales module (2026-09-28) ------------------------------------------------

// Measurement header: RO / SO / outlet, manager / supervisor / end users, and
// the fund, stock and man power punched on the complaint.
export const getMeasurementComplaintSummary = async (complaintId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-complaint-summary/${complaintId}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Clone Final PO: complaints a Final measurement can be copied onto.
// params: export filters (type / columns / ro_id / sale_area_id / ...), see exportCloneTargets
export const getCloneTargets = async (measurementId, params = {}) => {
  try {
    const extra = QUERY_PARAMS(params);
    const { data } = await customApi.get(
      `/api/contractor/billing/measurement/get-clone-targets?measurement_id=${measurementId}${extra ? `&${extra}` : ""}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Create Invoice line table (part-billing): measured / billed / left per line.
export const getBillableLines = async (piIds) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-billable-lines?pi_ids=${[].concat(piIds || []).join(",")}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Clone Final PO onto several complaints at once; every copy is a Draft.
// body: { measurement_id, complaint_ids: [], measurement_date }
export const bulkCloneMeasurement = async (body) => {
  try {
    const { data } = await customApi.post(`/api/contractor/billing/measurement/bulk-clone`, body);
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Billing From on a PI: companies with a GST registration and their states.
export const getBillingFromGstStates = async (companyId) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/performa-invoice/get-billing-from-gst-states${companyId ? `?company_id=${companyId}` : ""}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Merged Proforma Invoice: draft -> Final.
export const finalizeMergedPi = async (id) => {
  try {
    const { data } = await customApi.post(
      `/api/contractor/billing/merged-performa/finalize-merged-pi/${id}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};

// Create Invoice: earliest / latest allowed invoice date for the chosen PIs.
export const getInvoiceDateLimits = async ({ pi_ids, invoice_id } = {}) => {
  try {
    const { data } = await customApi.get(
      `/api/contractor/billing/invoice/get-invoice-date-limits?pi_ids=${(pi_ids || []).join(",")}&invoice_id=${invoice_id || ""}`,
    );
    return data;
  } catch (error) {
    return { status: false, message: error.response?.data.message || error.message };
  }
};
